"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SharesInfo_1 = __importDefault(require("@Components/ViewWork/SharesInfo"));
const ViewWorkSection_1 = __importDefault(require("@Components/ViewWork/ViewWorkSection"));
const react_1 = __importStar(require("react"));
const generate_edit_link_1 = __importDefault(require("@App/helpers/generate-edit-link"));
const contact_1 = require("@App/api/routes/rightsholder/contact");
const PublisherList_1 = __importDefault(require("@Components/ViewWork/PublisherList"));
const EditButton_1 = require("@Components/ViewWork/EditButton");
const PublishersSection = (props) => {
    const { publishers, workId, rightsholderId, totalKnownShares, myShares, workType, editing, publisherErrors } = props;
    const publishersEditLink = (0, generate_edit_link_1.default)('publishers', workId, rightsholderId, workType);
    const [publicContacts, setPublicContacts] = (0, react_1.useState)({ count: 0, data: [] });
    const getPublicContactsForPublishers = () => __awaiter(void 0, void 0, void 0, function* () {
        const adminIpIds = publishers
            .flatMap((publisher) => publisher.administratorPublishers)
            .map((ap) => ap.topMemberIpId && +ap.topMemberIpId);
        const originalIpIds = publishers
            .filter((publisher) => !publisher.administratorPublishers.length)
            .map((op) => op.topMemberIpId && +op.topMemberIpId);
        const ipIds = [...adminIpIds, ...originalIpIds].filter((ipid) => !!ipid);
        if (ipIds.length) {
            const response = yield (0, contact_1.getPublicContacts)(ipIds);
            setPublicContacts(response.data);
        }
    });
    const getPublicContactByIpId = (publisher) => { var _a; return (_a = publicContacts === null || publicContacts === void 0 ? void 0 : publicContacts.data) === null || _a === void 0 ? void 0 : _a.find((contact) => (contact === null || contact === void 0 ? void 0 : contact.ipId) === publisher.topMemberIpId); };
    (0, react_1.useEffect)(() => {
        ;
        (workType === 'work' || workType === 'overclaim') && getPublicContactsForPublishers();
    }, []);
    return (react_1.default.createElement(ViewWorkSection_1.default, { valid: props.editing !== undefined ? !publisherErrors : undefined, icon: 'publishers', title: 'Publishers', count: publishers.length, rightData: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(SharesInfo_1.default, { totalShares: totalKnownShares, myShares: myShares }),
            editing && (react_1.default.createElement(EditButton_1.EditButton, { linkTo: publishersEditLink, workType: props.workType, wizardFlowIndex: 3 }))) }, publishers.length ? (react_1.default.createElement(PublisherList_1.default, { publishers: publishers, totalKnownShares: totalKnownShares, myShares: myShares, publisherErrors: publisherErrors, getPubContactByIpId: getPublicContactByIpId, workType: workType })) : (react_1.default.createElement("div", { className: 'missing-records' }, "No publishers listed"))));
};
exports.default = PublishersSection;
